// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface EnterpriseNoticeAcceptanceLogsV1 {
  id: string;
  userId: number;
  noticeId: string;
  emails: Array<string>;
  thirdPartyOrganizationId: string;
  languageCode: string;
  timestamp: number;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface EnterpriseNoticeAcceptanceLogsV1Connection {
  elements: Array<EnterpriseNoticeAcceptanceLogsV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface EnterpriseNoticeAcceptanceLogsV1DeleteQuery {
  EnterpriseNoticeAcceptanceLogsV1: {
    delete: EnterpriseNoticeAcceptanceLogsV1Connection | null;
  } | null;
}

export interface EnterpriseNoticeAcceptanceLogsV1DeleteQueryVariables {
  id: string;
  includes?: string | null;
}

export interface EnterpriseNoticeAcceptanceLogsV1GetQuery {
  EnterpriseNoticeAcceptanceLogsV1: {
    get: EnterpriseNoticeAcceptanceLogsV1Connection | null;
  } | null;
}

export interface EnterpriseNoticeAcceptanceLogsV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface EnterpriseNoticeAcceptanceLogsV1GetByUserIdQuery {
  EnterpriseNoticeAcceptanceLogsV1: {
    getByUserId: EnterpriseNoticeAcceptanceLogsV1Connection | null;
  } | null;
}

export interface EnterpriseNoticeAcceptanceLogsV1GetByUserIdQueryVariables {
  userId: string;
  includes?: string | null;
}

export interface EnterpriseNoticeAcceptanceLogsV1GetByUserIdAndOrganizationIdQuery {
  EnterpriseNoticeAcceptanceLogsV1: {
    getByUserIdAndOrganizationId: EnterpriseNoticeAcceptanceLogsV1Connection | null;
  } | null;
}

export interface EnterpriseNoticeAcceptanceLogsV1GetByUserIdAndOrganizationIdQueryVariables {
  userId: string;
  thirdPartyOrganizationId: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface EnterpriseNoticeAcceptanceLogsV1CreateMutation {
  EnterpriseNoticeAcceptanceLogsV1: {
    create: EnterpriseNoticeAcceptanceLogsV1Connection | null;
  } | null;
}

export interface EnterpriseNoticeAcceptanceLogsV1CreateMutationVariables {
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
      ? PartialConstruction<T[TKey]>
      : T[TKey];
};

export class EnterpriseNoticeAcceptanceLogsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'enterpriseNoticeAcceptanceLogs.v1' as const;

  declare id: string;

  declare userId: number;

  declare noticeId: string;

  declare emails: Array<string>;

  declare thirdPartyOrganizationId: string;

  declare languageCode: string;

  declare timestamp: number;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<EnterpriseNoticeAcceptanceLogsV1>) {
    super(params);
  }
}
